import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { SystemPOWorkflowManagementPage } from './system_po_workflow_management_page.component';

/**
 * System Admin Invoice Management -> Vendor Invoice Management (PO Workflow)
 * Separate route + permission gating.
 * Note: does NOT reuse Vendor PO Workflow module.
 */
export default function SystemPOWorkflowManagement() {
  const navigate = useNavigate();
  const permissionNames = useMemo(() => {
    try {
      const stored = localStorage.getItem('permissions');
      if (!stored) {
        return [];
      }
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.map((p) => p.name) : [];
    } catch (error) {
      console.error('Failed to parse permissions:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (!permissionNames.includes('System Invoice Management')) {
      navigate('/rov', { replace: true });
    }
  }, [permissionNames, navigate]);

  return <SystemPOWorkflowManagementPage />;
}
